import React, { useEffect, useState } from 'react';
import MainLayout from '../../../layout/mainLayout';
import {
  Typography,
  Grid,
  Button,
  FormControl,
  FormHelperText,
} from '@mui/material';
import ApiClient from '../../../config/api';
import InputBox from '../../../components/inputBox';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const EditProfile = () => {
  const api = ApiClient();
  const [lastName, setLastName] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState({ field: '', message: '' });
  const navigate = useNavigate();

  const onSubmit = async () => {
    if (!name) {
      setError({ field: 1, message: 'لطفا نام را وارد نمایید' });
    } else if (!lastName) {
      setError({ field: 2, message: 'لطفا نام خانوادگی را وارد نمایید' });
    } else if (lastName && name) {
      const isValid = /\S+@\S+\.\S+/.test(email);
      if (email && isValid) {
        setError({ field: '', message: '' });
      } else {
        if (email && !isValid) {
          setError({ field: 3, message: 'ایمل وارد شده صحیح نمیباشد' });
          return;
        }
      }
      try {
        setError({ field: '', message: '' });
        setIsLoading(true);
        const response = await api.put('/api/app/v1/user/profile', {
          firstName: name,
          lastName: lastName,
          email: email,
        });
        await getData();
        navigate('/profile', { replace: true });
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setError({ field: 0, message: error?.response?.message });
      }
    } else {
      setError({ field: 0, message: 'لطفا نام و نام خانوادگی را وارد نمایید' });
    }
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(`/api/app/v1/user/whoami`);
      if (response?.data) {
        localStorage.setItem(
          'info',
          JSON.stringify({
            ...response?.data,
            token: JSON.parse(localStorage.getItem('info'))?.token,
            refresh_token: JSON.parse(localStorage.getItem('info'))
              ?.refresh_token,
          })
        );
      }
      setName(response?.data?.first_name);
      setLastName(response?.data?.last_name);
      setEmail(response?.data?.email);
      setMobile(response?.data?.mobile_no);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError({ field: 0, message: error?.response?.message });
    }
  };

  const handleNameChange = (newValue) => {
    setName(newValue);
  };

  const handleLastNameChange = (newValue) => {
    setLastName(newValue);
  };

  const handleEmailChange = (newValue) => {
    setEmail(newValue);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <MainLayout>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        marginTop={'20px'}
        container
        justifyContent={'space-between'}
      >
        <Grid item display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <KeyboardBackspaceIcon
            className={'clickable'}
            sx={{
              transform: 'rotate(180deg)',
              cursor: 'pointer',
              marginRight: '8px',
              fontSize: '24px',
            }}
            onClick={() => {
              navigate('/profile', { replace: true });
            }}
          />
          <Typography fontSize={20} fontWeight={600}>
            ویرایش پروفایل
          </Typography>
        </Grid>
      </Grid>
      <Grid
        paddingRight={'20px'}
        paddingLeft={'20px'}
        marginTop={'32px'}
        container
        flexDirection={'column'}
      >
        <Grid item>
          <InputBox
            label="نام"
            value={name}
            setValue={handleNameChange}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="text"
            icon={null}
            error={error?.field == 1 ? error?.message : null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="نام خانوادگی"
            value={lastName}
            setValue={handleLastNameChange}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="text"
            icon={null}
            error={error?.field == 2 ? error?.message : null}
          />
        </Grid>
        <Grid item>
          <InputBox
            label="ایمیل (اختیاری)"
            value={email}
            setValue={handleEmailChange}
            onSubmit={onSubmit}
            isLoading={isLoading}
            type="email"
            icon={null}
            error={error?.field == 3 ? error?.message : null}
          />
        </Grid>
        <Grid item>
          <FormControl
            size="small"
            variant="standard"
            fullWidth
            error={Boolean(error?.field)}
          >
            {error?.field == 0 && (
              <FormHelperText>{error?.message}</FormHelperText>
            )}
          </FormControl>
          <Button
            onClick={onSubmit}
            disabled={isLoading}
            sx={{
              marginTop: '24px',
              width: '100%',
              height: '57px',
              borderRadius: '8px',
              color: 'primary.contrastText',
              fontFamily: 'iran-sans-light',
              fontSize: '16px',
              fontWeight: '600',
              marginTop: '0px',
            }}
            size="large"
            variant="contained"
          >
            {isLoading ? <CircularProgress size={24} sx={{ color: 'primary.contrastText' }} /> : 'تایید و ادامه'}
          </Button>
        </Grid>
      </Grid>
    </MainLayout>
  );
};

export default EditProfile;
